import { memo } from 'react';

import ReviewFilledIconSVG from '@/assets/review-filled-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IReviewFilledIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={ReviewFilledIconSVG} {...props} />
);

export const ReviewFilledIcon = memo(IReviewFilledIcon) as typeof IReviewFilledIcon;
